// Creates a pair of functions that implement load-once + mount-once with retry
// on failure. Designed for below-the-fold chunks that are triggered from
// multiple sites (IntersectionObserver + requestIdleCallback) without
// coordination overhead.
//
// loadSection  — memoises the async chunk; clears the memo on failure so the
//                next invocation (idle callback, intersection retry) can retry.
// mountSection — guards against double-mount; resets the guard on failure so a
//                later call can attempt again after a transient chunk error.
export function createDeferredMounter({ loadChunk, onMount, onError }) {
  let chunkReady = null

  const loadSection = () => {
    if (!chunkReady) {
      chunkReady = loadChunk().catch((error) => {
        chunkReady = null
        return Promise.reject(error)
      })
    }
    return chunkReady
  }

  let mounted = false

  const mountSection = () => {
    if (mounted) return
    mounted = true
    loadSection().then(
      () => { onMount() },
      (error) => {
        mounted = false
        onError(error)
      }
    )
  }

  return { loadSection, mountSection }
}
